<template>
    <div v-if="!!tree">
      <div class="container">
        <div class="item">
          <label class="dock-pull-select-label" v-if="selected === 'mode'">
            <select v-model="objectFilter" class="dock-pull-select">
              <option value="1">{{$t('devices.mode.test_label')}}</option>
              <option value="2">{{$t('devices.mode.tracker_label')}}</option>
              <option value="3">{{$t('devices.mode.leasing_label')}}</option>
              <option value="4">{{$t('devices.mode.search_label')}}</option>
              <option value="5">{{$t('devices.mode.secure_label')}}</option>
            </select>
          </label>
          <input v-model="objectFilter" type="search" :placeholder="$t('devices.list.search_label')"
                 class="dock-pull-input" v-else>
        </div>
        <div class="item">
          <label class="dock-pull-select-label">
            <select v-model="selected" class="dock-pull-select">
              <option v-for="option in filterOptions" v-bind:key="option.id" v-bind:value="option.value">
                {{option.text}}
              </option>
            </select>
          </label>
        </div>
      </div>
      <DynamicScroller
        :items="tree" :min-item-size="60" class="tree-node scroller"
        key-field="id" v-if="tree.length" page-mode>
        <template v-slot="{ item, index, active }">
          <div class="tree-node">
            <DynamicScrollerItem v-if="!!item.data" :item="item" :active="active"
                                 :size-dependencies="[item.text]"
                                 :data-index="index" class="tree-content">
              <div class="tree-object">
                <div class="tree-object-icon" @click="currentObject(item.id)">
                  <img class="tree-icon" :alt="item.text" :src="item.data.icon">
                </div>
                <div class="tree-object-text">
                  <div class="tree-object-text-header">{{item.text | truncate(15)}}</div>
                  <div class="tree-object-text-desc" v-if="item.data.date <= now_date">{{item.data.date | moment('calendar')}}</div>
                  <div class="tree-object-text-desc" v-else>{{$t('devices.no_data_label')}}</div>
                </div>
                <div class="tree-object-tools">
                  <span class="dock-pull-notify" v-if="item.data.date <= now_date && dateDifference(item.data.date, now_date) > 7"><i class="far fa-2x fa-engine-warning"></i>&nbsp;&nbsp;</span>
                  <i class="far fa-edit fa-2x" @click.stop="$router.push({name: 'device', params: {id: item.id}})"></i>
<!--                  <i class="far fa-route fa-2x" @click.stop="curObject(item.id)"></i>-->
                </div>
              </div>
            </DynamicScrollerItem>
            <DynamicScrollerItem :item="item" :active="active"
                                 :size-dependencies="[item.text]"
                                 :data-index="index" class="tree-content" v-else>
              <i @click.stop="collapseTreeGroup(item.idxg)" v-bind:class="{ expanded: item.collapsed }" class="tree-arrow has-child ltr"></i>
              <div @click.stop="collapseTreeGroup(item.idxg)"  class="tree-anchor">
                <span class="tree-text-header">
                  {{item.text}} ({{item.length}})
                </span>
              </div>
            </DynamicScrollerItem>
          </div>
        </template>
      </DynamicScroller>

      <div class="container" v-else>
        <div class="item">
          <div class="dock-pull-list-text">
            <div class="dock-pull-list-header">
              <h3>{{$t('devices.list.not_found_label')}}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex'

export default {
  name: 'Devices',
  data () {
    return {
      selected: 'name',
      filterOptions: [
        {id: 0, text: this.$t('devices.list.name_label'), value: 'name'},
        {id: 1, text: this.$t('devices.list.imei_label'), value: 'imei'},
        {id: 2, text: this.$t('devices.list.sim_label'), value: 'phone'},
        {id: 3, text: this.$t('devices.list.mode_label'), value: 'mode'}
      ],
      treeFilter: '',
      modeFilter: 3
    }
  },
  computed: {
    ...mapGetters({
      getObjTree: 'getObjectFromTree',
      treeRecycle: 'treeRecycle',
      dateDifference: 'dateDifference',
      now_date: 'nowDate'
    }),
    objectFilter: {
      get () {
        return this.selected === 'mode' ? this.modeFilter : this.treeFilter
      },
      set (n) {
        if (this.selected === 'mode') { this.modeFilter = n } else { this.treeFilter = n }
      }
    },
    tree () {
      return this.treeRecycle(this.objectFilter, this.selected)
    }
  },
  methods: {
    ...mapMutations(['dockVisibility', 'collapseTreeGroup', 'fitNewMarker']),
    ...mapActions({
      curObj: 'setCurrentDevice',
      objHistory: 'getObjectHistory'
    }),
    currentObject (id) {
      const object = this.getObjTree(id)
      this.curObj({
        idx: object.idx,
        idxg: object.idxg,
        id: id,
        group_id: object.obj.group_id
      }).then(() => {
        this.fitNewMarker(object.obj)
        this.dockVisibility(false)
        this.$router.push({name: 'Quick'})
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/devices/active/Devices.vue